<template>
    <div class="animated fadeIn">
        <Request
                ref="requestBinderFolder"
                method="GET"
                :onRequestSuccess="onRequestSuccess"
                @onInit="onInit"
                root="/binder/folder">
            <slot slot="body">

                <div>
                    <b-row>
                        <b-col>
                            <b-button-group>
                                <b-button :disabled="dataBinderIndex === false || dataBinderIndex.prevPosition === false" @click="binderIndexOnClickPrev" class="btn btn-light">
                                    <i class="fa fa-chevron-left"></i>
                                </b-button>
                                <b-button v-if="dataBinderIndex !== false" @click="binderIndexOnClickOpenList"  class="btn btn-light">
                                    {{dataBinderIndex.position}} - {{dataBinderIndex.title}}
                                </b-button>
                                <b-button :disabled="dataBinderIndex === false" @click="binderIndexOnClickNext" class="btn btn-light">
                                    <i class="fa fa-chevron-right"></i>
                                </b-button>
                                <b-button @click="binderIndexOnClickAdd" href="#" class="ml-2 btn btn-light">
                                    <i class="fa fa-plus"></i> {{Core.Definition.getDefinition('Nouvel index')}}
                                </b-button>
                            </b-button-group>
                        </b-col>
                        <b-col class="text-right">
                        </b-col>
                    </b-row>
                </div>

                <hr/>

                <div v-if="dataBinderIndex !== false">

                    <div v-if="dataBinderIndex.indexType === 'note'">
                        <Request
                                ref="requestBinderIndexNote"
                                method="PUT"
                                root="/binder-note"
                                :onRequestSuccess="onRequestSuccess">
                            <slot slot="body">
                                <b-row class="mt-4 mb-4 binder-form">
                                    <b-col>
                                        <textarea
                                                type="text"
                                                style="width:97%; padding: 10px"
                                                rows="10"
                                                v-model="dataBinderIndex.description">
                                        </textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="pr-5 pl-5">
                                    <b-col class="text-right">
                                        <b-button @click="binderIndexNoteOnSaveClick" class="btn btn-success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                                    </b-col>
                                </b-row>
                            </slot>
                        </Request>
                    </div>

                    <div v-if="dataBinderIndex.indexType === 'index'">

                        <b-row class="mt-5">
                            <b-col class="text-center">
                                <b-button-group>
                                    <b-button :disabled="dataBinderForm === false || dataBinderForm.prevPosition === false" @click="binderFormOnClickPrev" class="btn btn-light">
                                        <i class="fa fa-chevron-left"></i>
                                    </b-button>
                                    <b-button v-if="dataBinderForm !== false && dataBinderForm.title !== ''" @click="binderFormOnClickOpenList" class="btn btn-light">
                                        {{ dataBinderForm.position }} - {{dataBinderForm.title}}
                                    </b-button>
                                    <b-button v-if="dataBinderForm !== false && dataBinderForm.title == ''" @click="binderFormOnClickOpenList" class="btn btn-light">
                                        {{ dataBinderForm.position }} - {{dataBinderForm.formTemplate.title}}
                                    </b-button>
                                    <b-button :disabled="dataBinderForm === false" @click="binderFormOnClickNext" class="btn btn-light">
                                        <i class="fa fa-chevron-right"></i>
                                    </b-button>
                                    <b-dropdown>
                                        <b-dropdown-item @click="createFromForm">
                                            <span>{{Core.Definition.getDefinition('Créer un modèle')}}</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="preview">
                                            <span>{{Core.Definition.getDefinition('Aperçu')}}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                    <b-button @click="binderFormOnClickAdd" href="#" class="ml-2 btn btn-light">
                                        <i class="fa fa-plus"></i> {{Core.Definition.getDefinition('Nouveau formulaire')}}
                                    </b-button>
                                </b-button-group>
                            </b-col>
                        </b-row>

                        <Request
                                ref="requestBinderFormMeta"
                                method="PUT"
                                :onRequestSuccess="onRequestSuccess"
                                root="/binder-form/save">
                            <slot slot="body">
                                <b-row class="mt-4 binder-form">
                                    <b-col>
                                        <CForm class="c-form-folder" v-if="dataBinderFormHide === false" ref="integratedForm" :structure="dataBinderForm.structure"></CForm>
                                    </b-col>
                                </b-row>
                                <b-row v-if="dataBinderIndex !== false && dataBinderForm !== false && dataBinderFormHide === false" class="pr-5 pl-5">
                                    <b-col class="text-right">
                                        <b-button-group>
                                            <b-button @click="binderFormMetaOnSaveClick" class="btn btn-default">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                                            <b-button @click="binderFormMetaOnSaveNextClick" class="btn btn-success">{{Core.Definition.getDefinition('Enregistrer + nouveau formulaire')}}</b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>
                            </slot>
                        </Request>
                    </div>

                </div>

                <div v-if="dataBinderIndex === false">
                    <b-alert variant="light" show="true">
                        {{Core.Definition.getDefinition('Cet dossier est vide. Veuillez créer un premier index.')}}<br/>
                    </b-alert>
                </div>

                <div v-if="dataBinderIndex !== false && dataBinderForm === false && dataBinderIndex.indexType === 'index'">
                    <b-alert variant="light" show="true">
                        {{Core.Definition.getDefinition('Cet index est vide. Veuillez créer un premier formulaire.')}}<br/>
                    </b-alert>
                </div>

            </slot>
        </Request>

        <ModalBinderIndex
                ref="modalBinderIndex"
                @onSaveSuccess="binderIndexOnSaveSuccess">
        </ModalBinderIndex>
        <ModalBinderForm
                ref="modalBinderForm"
                @onSaveSuccess="binderFormOnSaveSuccess">
        </ModalBinderForm>

        <b-modal :title="Core.Definition.getDefinition('Index')" :hide-footer="true" v-model="dataModalBinderIndexList.show">
            <DynamicList
                    key="dynamicCardListBinderIndex"
                    ref="dynamicCardListBinderIndex"
                    @onRetrieve="binderIndexOnRetrieveList"
                    :actions="dataModalBinderIndexList.actions"
                    :searchFormStructure="dataModalBinderIndexList.searchFormStructure"
                    :columns="dataModalBinderIndexList.columns"
                    root="/binder-index/list">
                <slot slot="cardTableHeaderActions">
                    <b-link @click="binderIndexOnClickAdd" href="#" class="card-header-action btn-setting">
                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Index')}}
                    </b-link>
                </slot>
            </DynamicList>
        </b-modal>

        <b-modal :title="Core.Definition.getDefinition('Formulaire')" :hide-footer="true" v-model="dataModalBinderFormList.show">
            <DynamicList
                    key="dynamicCardListBinderForm"
                    ref="dynamicCardListBinderForm"
                    class="mt-2"
                    @onRetrieve="binderFormOnRetrieveList"
                    :actions="dataModalBinderFormList.actions"
                    :searchFormStructure="dataModalBinderFormList.searchFormStructure"
                    :columns="dataModalBinderFormList.columns"
                    root="/binder-form/list">
                <slot slot="cardTableHeaderActions">
                    <b-link @click="binderFormOnClickAdd"  href="#" class="card-header-action btn-setting">
                        <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Formulaire')}}
                    </b-link>
                </slot>
            </DynamicList>
        </b-modal>

        <ModalTrash
                ref="modalTrashBinderIndex"
                root="/binder-index"
                @onTrashSuccess="binderIndexOnTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'index')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet index?')"></ModalTrash>
        <ModalTrash
                ref="modalTrashBinderForm"
                root="/binder-form"
                @onTrashSuccess="binderFormOnTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du formulaire')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce formulaire?')"></ModalTrash>


        <ModalFormTemplate ref="modalFormTemplate"></ModalFormTemplate>
        <ModalFormTemplatePreview ref="modalFormTemplatePreview"></ModalFormTemplatePreview>


    </div>
</template>

<script>
    import Request from '../../../components/Request'
    import CForm from '../../../components/CForm'
    import ModalBinderIndex from '../../../components/ModalBinderIndex'
    import ModalBinderForm from '../../../components/ModalBinderForm'
    import DynamicList from '../../../components/DynamicList'
    import ModalTrash from '../../../components/ModalTrash'
    import ModalFormTemplate from '../../../components/ModalFormTemplate'
    import ModalFormTemplatePreview from '../../../components/ModalFormTemplatePreview'

    export default {
        name: 'BinderFolder',
        components: {
            Request,
            CForm,
            ModalBinderIndex,
            ModalBinderForm,
            DynamicList,
            ModalTrash,
            ModalFormTemplate,
            ModalFormTemplatePreview
        },
        props: {
            binderId: {
                type: Number | String,
                default: ''
            }
        },
        watch: {
        },
        mounted() {
            if (Core.Validation.isId(this.$route.params.id)) {
                this.dataBinderId = this.$route.params.id
            } else {
                if (Core.Validation.isId(this.binderId)) {
                    this.dataBinderId = this.binderId
                }
            }
            if (Core.Validation.isId(this.dataBinderId)) {
                this.request()
            }
        },
        computed: {
            binderIndex: {
                set(val) {
                    this.dataBinderIndex = val
                },
                get() {
                    return this.dataBinderIndex
                }
            },
            binderForm: {
                set(val) {
                    this.dataBinderForm = val
                },
                get() {
                    return this.dataBinderForm
                }
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataBinderId: '',
                dataLoadOnMounted: true,
                dataCallback: '',
                dataBinder: {},
                dataBinderIsEmpty: false,
                dataBinderIndex: false,
                dataBinderForm: false,
                dataBinderFormHide: false,
                dataModalBinderIndexList: {
                    show: false,
                    actions: [
                        {
                            key: 'edit',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-edit"></i></button>',
                            callBack: this.binderIndexOnClickEdit
                        },
                        {
                            key: 'view',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-folder-open-o"></i></button>',
                            callBack: this.binderIndexOnClickFolder
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderIndexOnClickTrash
                        }
                    ],
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Position'),
                            key: 'position',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Titre'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Type'),
                            key: 'indexType',
                            sortable: true
                        }
                    ]
                },
                dataModalBinderFormList: {
                    show: false,
                    actions: [
                        {
                            key: 'edit',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-edit"></i></button>',
                            callBack: this.binderFormOnClickEdit
                        },
                        {
                            key: 'view',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-folder-open-o"></i></button>',
                            callBack: this.binderFormOnClickFolder
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderFormOnClickTrash
                        }
                    ],
                    searchFormStructure: {},
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Position'),
                            key: 'position',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('title'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Modèle'),
                            key: 'formTemplateId',
                            sortable: true,
                            type: 'select'
                        }
                    ]
                }
            }
        },
        methods: {
            preview() {
                this.$refs.modalFormTemplatePreview.open(this.dataBinderForm.formTemplateId, this.dataBinderForm.id)
            },
            createFromForm() {
                this.$refs.modalFormTemplate.open(this.dataBinderId, this.dataBinderIndex.id, this.dataBinderForm.id)
            },
            onInit() {
            },
            request(binderIndexId, binderFormId, binderIndexPosition, binderFormPosition) {

                this.dataBinderFormHide = true

                this.$refs.requestBinderFolder.setMethod('GET')

                this.$refs.requestBinderFolder.addArg('binderId', this.dataBinderId)

                if (Core.Validation.isId(binderIndexId)) {
                    this.$refs.requestBinderFolder.addArg('binderIndexId', binderIndexId)
                } else {
                    this.$refs.requestBinderFolder.addArg('binderIndexId', '')
                }

                if (Core.Validation.isId(binderFormId)) {
                    this.$refs.requestBinderFolder.addArg('binderFormId', binderFormId)
                } else {
                    this.$refs.requestBinderFolder.addArg('binderFormId', '')
                }

                if (!Core.Validation.isEmpty(binderIndexPosition)) {
                    this.$refs.requestBinderFolder.addArg('binderIndexPosition', binderIndexPosition)
                } else {
                    this.$refs.requestBinderFolder.addArg('binderIndexPosition', '')
                }

                if (!Core.Validation.isEmpty(binderFormPosition)) {
                    this.$refs.requestBinderFolder.addArg('binderFormPosition', binderFormPosition)
                } else {
                    this.$refs.requestBinderFolder.addArg('binderFormPosition', '')
                }
                this.$refs.requestBinderFolder.request()
            },
            onRequestSuccess(data) {
                this.dataBinderFormHide = false
                if(data.binderIndex !== undefined) {
                    this.dataBinderIndex = data.binderIndex
                }
                if (data.binderForm !== undefined) {
                    this.dataBinderForm = data.binderForm
                    this.dataBinderFormHide = false
                }
                if (undefined !== data.next) {
                    switch(data.next){
                        case 'form':
                            this.binderFormOnClickAdd()
                            break
                    }
                } else {
                }
                this.$forceUpdate()
            },
            binderIndexOnClickPrev() {
                if (Core.Validation.isId(this.dataBinderIndex.prevPosition)) {
                    this.request(false, false, this.dataBinderIndex.prevPosition, false)
                } else {
                }
            },
            binderIndexOnClickNext() {
                if (Core.Validation.isId(this.dataBinderIndex.nextPosition)) {
                    this.request(false, false, this.dataBinderIndex.nextPosition, false)
                } else {
                    this.binderIndexOnClickAdd()
                }
            },
            binderFormOnClickPrev() {
                if (Core.Validation.isId(this.dataBinderForm.prevPosition)) {
                    this.request(this.dataBinderIndex.id, false, false, this.dataBinderForm.prevPosition)
                } else {
                }
            },
            binderFormOnClickNext() {
                if (Core.Validation.isId(this.dataBinderForm.nextPosition)) {
                    this.request( this.dataBinderIndex.id, false, false, this.dataBinderForm.nextPosition)
                } else {
                    this.binderFormOnClickAdd()
                }
            },
            binderIndexOnClickOpenList() {
                this.dataModalBinderIndexList.show = true
            },
            binderIndexOnClickAdd() {
                this.$refs.modalBinderIndex.binderId = this.dataBinderId
                this.$refs.modalBinderIndex.id = ''
                this.$refs.modalBinderIndex.open = true
            },
            binderIndexOnClickEdit(value, cell, row) {
                this.$refs.modalBinderIndex.binderId = this.dataBinderId
                this.$refs.modalBinderIndex.id = row.id
                this.$refs.modalBinderIndex.open = true
            },
            binderIndexOnClickForms(value, cell, row) {
                this.dataBinderIndex = {
                    id: row.id,
                    title: row.title,
                    position: row.position,
                    type: row.type
                }
            },
            binderIndexOnClickFolder(value, cell, row) {
                this.dataBinderFormHide = true
                let binderIndexId = row.id
                this.request(binderIndexId)
                this.dataModalBinderIndexList.show = false
            },
            binderIndexOnClickTrash(value, cell, row) {
                this.dataModalBinderIndexList.show = false
                this.$refs.modalTrashBinderIndex.open(row.id)
            },
            binderIndexOnTrashSuccess() {
                this.$refs.modalTrashBinderIndex.open = false
                this.request()
            },
            binderIndexOnRetrieveList() {
                this.$refs.dynamicCardListBinderIndex.$refs.request.addArg('binderId', this.dataBinderId)
                this.$refs.dynamicCardListBinderIndex.$refs.request.addArg('binderIndexPosition', this.dataBinderIndex.position)
            },
            binderIndexOnSaveSuccess(data) {
                this.$refs.modalBinderIndex.open = false
                if (data.binderIndex !== undefined) {
                    if (Core.Validation.isId(data.binderIndex.id)) {
                        this.request(data.binderIndex.id)
                    }
                }
            },
            binderFormOnClickOpenList() {
                this.dataModalBinderFormList.show = true
            },
            binderFormOnClickAdd() {
                this.$refs.modalBinderForm.binderId = this.dataBinderId
                this.$refs.modalBinderForm.binderIndexId = this.dataBinderIndex.id
                this.$refs.modalBinderForm.id = ''
                this.$refs.modalBinderForm.open = true
            },
            binderFormOnClickEdit(value, cell, row) {
                this.$refs.modalBinderForm.binderId = this.dataBinderId
                this.$refs.modalBinderForm.binderIndexId = this.dataBinderIndex.id
                this.$refs.modalBinderForm.id = row.id
                this.$refs.modalBinderForm.open = true
            },
            binderFormOnClickFolder(value, cell, row) {
                this.dataBinderFormHide = true
                let binderIndexId = this.dataBinderIndex.id
                let binderFormId = row.id
                this.request(binderIndexId, binderFormId, false, false)
                this.dataModalBinderFormList.show = false
            },
            binderFormOnClickTrash(value, cell, row) {
                this.dataModalBinderFormList.show = false
                this.$refs.modalTrashBinderForm.open(row.id)
            },
            binderFormOnTrashSuccess() {
                this.request()
            },
            binderFormOnRetrieveList() {
                this.$refs.dynamicCardListBinderForm.$refs.request.addArg('binderId', this.dataBinderId)
                this.$refs.dynamicCardListBinderForm.$refs.request.addArg('binderIndexId', this.dataBinderIndex.id)
                this.$refs.dynamicCardListBinderForm.$refs.request.addArg('binderFormPosition', this.dataBinderForm.position)
            },
            binderFormOnClickBack() {
                this.dataBinderIndex = false
            },
            binderFormOnSaveSuccess(data) {
                this.$refs.modalBinderForm.open = false

                if (data.binderForm !== undefined) {
                    if (Core.Validation.isId(data.binderForm.id)) {
                        this.request(data.binderForm.binderIndexId, data.binderForm.id)
                    }
                }

                if (this.$refs.dynamicCardListBinderForm !== undefined) {
                    this.$refs.dynamicCardListBinderForm.retrieve()
                }
            },
            binderIndexNoteOnSaveClick() {
                this.$refs.requestBinderIndexNote.dataMethod = 'PUT'
                this.$refs.requestBinderIndexNote.dataRoot = '/binder-note'
                this.$refs.requestBinderIndexNote.addArg('binderId', this.dataBinderId)
                this.$refs.requestBinderIndexNote.addArg('binderIndexId', this.dataBinderIndex.id)
                this.$refs.requestBinderIndexNote.addArg('description', this.dataBinderIndex.description)
                this.$refs.requestBinderIndexNote.request()
            },
            binderFormMetaOnSaveClick() {
                this.binderFormMetaSave()
            },
            binderFormMetaOnSaveNextClick() {
                this.binderFormMetaSave('form')
            },
            binderFormMetaSave(next) {

                let integratedForm = this.$refs.integratedForm

                let spreadsheets = []



                if(integratedForm.fieldRefs !== undefined) {
                    let fieldRefs = integratedForm.fieldRefs
                    for(let fieldRefId in fieldRefs) {
                        let fieldRef = fieldRefs[fieldRefId]

                        if(fieldRef.hotInstance !== undefined) {
                            let spreadsheet = {
                                id: fieldRefId,
                                data: {
                                    spreadsheet: {
                                        settings: Core.Spreadsheet.extractSettings(fieldRef)
                                    },
                                    readOnlyData: fieldRef.hotInstance.getData()
                                }
                            }
                            spreadsheets.push(spreadsheet)
                        }
                    }
                }

                this.$refs.requestBinderFolder.setMethod('PUT')
                if (this.$refs.integratedForm !== undefined) {
                    if (!this.$refs.integratedForm.validate()) {
                        return false
                    } else {
                        let form = {
                            formTemplateId: this.dataBinderForm.formTemplateId,
                            values: this.$refs.integratedForm.getValues(),
                        }
                        this.$refs.requestBinderFormMeta.addArg('form', JSON.stringify(form))
                        this.$refs.requestBinderFormMeta.addArg('spreadsheets', JSON.stringify(spreadsheets))
                        this.$refs.requestBinderFormMeta.addArg('binderId', this.dataBinderId)
                        this.$refs.requestBinderFormMeta.addArg('binderIndexId', this.dataBinderIndex.id)
                        this.$refs.requestBinderFormMeta.addArg('binderFormId', this.dataBinderForm.id)
                        this.$refs.requestBinderFormMeta.addArg('next', next)
                        this.$refs.requestBinderFormMeta.request()
                    }
                }
            }
        }
    }
</script>
